import React, {useContext, useEffect} from 'react';
import {Box, CssBaseline} from "@mui/material";
import {Redirect, Route, Switch} from "react-router-dom";
import PinbikerProfile from "./Pinbiker/PinbikerProfile";
import PinbikerHeader, {PINBIKER_HEADER_HEIGHT} from "./Pinbiker/PinbikerHeader";
import Page404 from "../components/pages/Page404";
import {UserContext} from "./App";
import {useQueryClient} from "react-query";
import {get, USERS,} from "../services/Client";
import {useSynchronizeCities} from "../services/ContentManager";
import {getBrand} from "../branding";

/**
 * Guscio del pinbiker: niente sidebar e niente header del backoffice, ma un header suo che segue il
 * marchio (white label, vedi branding.js). Sfondo grigio come il login.
 */
export default function MainPinbiker() {

    const loggedUser = useContext(UserContext);
    const queryClient = useQueryClient()
    const brand = getBrand();

    useEffect(() => {
        if (!loggedUser.organization) return;
        queryClient.prefetchQuery([USERS, {oid: loggedUser.organization}], () => get(USERS, {params: {oid: loggedUser.organization}}))
    }, [loggedUser, queryClient])

    useSynchronizeCities();

    return (
        <Box sx={{minHeight: '100vh', maxWidth: '100vw', bgcolor: '#f4f5f7'}}>
            <CssBaseline/>
            <PinbikerHeader brand={brand}/>

            <Box component="main" sx={{pt: `${PINBIKER_HEADER_HEIGHT + 24}px`, px: {xs: 1.5, md: 3}, pb: 4}}>
                <Switch>

                    {/* la scheda iniziale (mappa o profilo) la sceglie PinbikerProfile */}
                    <Route path={"/profile/:uid/:filter?"}>
                        <PinbikerProfile/>
                    </Route>
                    <Redirect exact from="/profile" to={"/profile/" + loggedUser.uid}/>

                    <Redirect exact from="/" to="/profile"/>
                    <Route path={"/"}>
                        <Page404/>
                    </Route>

                </Switch>
            </Box>
        </Box>
    );
}
